import reset_img from './images/reset.svg'

export default function CustomizationCard({title, handleReset=null, children, className=""}){
    return (
        <>
            <div className={`cs_card ${className}`}>
                <h3>{title}</h3>
                <div className="row">
                    <div className='col-11'>
                        {children}
                    </div>
                    {handleReset !== null?
                        <img src={reset_img} onClick={handleReset} className='col-1'/>
                    : ""}
                </div>
                

            </div>
        </>
    )
}